export default "__VITE_ASSET__CeFQYO01__"